import { SchemaTransformerArgs } from '@web-config-app/core';
import jsonLogic from 'json-logic-js';
import { getConditionOfType } from '../get-condition-of-type/get-condition-of-type';

/**
 * This function handles the `disabledIf` type of `x-entity-conditional` annotation
 * @param schema - the current schema slice
 * @param data - the form data
 * @returns an annotatedJsonSchema with the readOnly flag set to true (which will disable a given control), if the json logic rule evaluates to true,
 * otherwise returns the schema as is
 */
export const evaluateDisabledIfCondition = ({
  schema,
  data,
  options,
}: SchemaTransformerArgs) => {
  const disabledIfCondition = getConditionOfType(schema, 'disabledIf');

  if (!disabledIfCondition) return schema;

  // Merge rootData under `$` key to support `$.path` references in JsonLogic var operator
  const dataToEvaluate = {
    ...data,
    ...(options?.rootData !== undefined && { $: options.rootData }),
    ...(options?.featureFlags !== undefined && {
      _featureFlags: options.featureFlags,
    }),
  };

  // TODO: Future enhancement (or not): this probably also need to traverse an object and recursively disable all child properties
  const computedSchema = jsonLogic.apply(
    disabledIfCondition.rules,
    dataToEvaluate,
  )
    ? {
        ...schema,
        readOnly: true,
      }
    : schema;
  return computedSchema;
};
